import { Permission } from './core/domain/model/permission';
// const baseUrl = "http://localhost:3000"
const baseUrl = process.env.VUE_APP_BASE_URL

declare global {
    interface Window { navigation: any; router: any; snackbarController: any; tzOffset: any, permissions: Array<Permission> }
}

export { baseUrl }